import { models } from '@kurtosys/ksys-app-template';
export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '025e16f6-7350-4189-9435-08717f70ff23',
	serviceUrl: 'https://www.columbiathreadneedle.com/services',
};